import { URL_LABEL } from "../../../../../content/index.content";

const salesEstimator = ({ language, isSavedUser }) => {
  return {
    title: "Sales Estimator",
    href: `/sales-estimator/?${URL_LABEL}`,
    subtitle:
      "Predict the number of sales for any given niche based on the sales rank",
    isLink: true,
  };
};

export default salesEstimator;
